import { render } from "./ArtificialIntelligenceView.vue?vue&type=template&id=bc9a277a&scoped=true"
import script from "./ArtificialIntelligenceView.vue?vue&type=script&lang=js"
export * from "./ArtificialIntelligenceView.vue?vue&type=script&lang=js"

import "./ArtificialIntelligenceView.vue?vue&type=style&index=0&id=bc9a277a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc9a277a"]])

export default __exports__